/**
 * @generated SignedSource<<4c8bd2f9594381391ed3a5bad70979ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usersField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId?: string;
  readonly name?: string;
  readonly selectedUsersConnection?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accountId: string;
        readonly name: string;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "usersField_updateWorkItemAllFieldTypesActionRenderer";
};
export type usersField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: usersField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usersField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "fieldId"
  },
  (v0/*: any*/),
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "concreteType": "JiraUserConnection",
    "kind": "LinkedField",
    "name": "selectedUsersConnection",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraUserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              (v0/*: any*/)
            ]
          }
        ]
      }
    ],
    "storageKey": "selectedUsersConnection(first:10)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usersField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "JiraPeopleField"
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "JiraMultipleSelectUserPickerField"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};
})();

(node as any).hash = "39c970a1d25061e97f184bd7ed9364c6";

export default node;
